module.exports = __webpack_public_path__ + "static/media/expand.590deaa6.svg";